import styled, { css } from "styled-components"
import { Box } from "@components/Layout"
import { breakpoints } from "@config/theme"

export const Error = styled.div`
  margin: -4px 0 0 20px;
  color: red;
  font-size: 12px;
  white-space: pre;

  @media (max-width: ${breakpoints.medium}) {
    margin-left: 10px;
  }
`

export const Wrapper = styled(Box)`
  width: 100%;
`

export const BasicInput = css`
  transition: border-color 0.2s ease-in-out;
  background: #ffffff;
  border: 1.5px solid ${(p) => p.theme.colors.softGrey};
  font-size: 1rem;
  letter-spacing: 0;
  height: 2.75rem;
  line-height: 2.75rem;
  padding: 0 0.75rem;
  border-radius: 0;
  outline: 0;
  -webkit-appearance: none;
  &:hover {
    border-color: ${(p) => p.theme.colors.text.light};
  }

  &:focus {
    border-color: ${(p) => p.theme.colors.purple};
  }

  &::placeholder {
    color: ${(p) => p.theme.colors.text.light};
  }

  &:disabled {
    cursor: not-allowed;
    &::placeholder {
      color: ${(p) => p.theme.colors.softGrey};
    }
    &:hover {
      border: 1.5px solid ${(p) => p.theme.colors.softGrey};
    }
  }
`
